import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import NcsMeetingView from "./ncsMeetingView";
import { getNcsMeetingbyId } from "services/redux/brandActivtion/meetings/action";

const mapStateToProps = (state) => ({
    ncsMeetingsData: state.baMeetingReducer.ncsMeetingData,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getNcsMeetingbyId,
        },
        dispatch
);
export default connect(mapStateToProps, mapDispatchToProps)(NcsMeetingView);